/**
 * Stock transfers list route — mounts `<StockTransfersPage />`.
 *
 * @see apps/web/src/features/inventory/stock/stock-transfers-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { StockTransfersPage } from "../../../../features/inventory/index.ts";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/inventory/stock-transfers/")({
  component: StockTransfersRoute,
});

function StockTransfersRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[{ label: "Inventory", to: "/" }, { label: "Transfers" }]}
      viewportClassName="p-0"
      contentClassName="max-w-none"
    >
      <StockTransfersPage />
    </WorkspaceShell>
  );
}
